<template>
  <div>
    <section class="search-region">
      <b-container>
        <b-row>
          <b-col>
            <form
              v-if="attachedView"
              ref="filterForm"
              action="#"
              @submit.prevent="filterView"
            >
              <div v-html="attachedView.filter_form" />
            </form>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <b-container>
      <b-row>
        <b-col>
          <node-element-local-tasks
            :nid="nid"
          />
          <div
            v-if="unpublished"
            class="messages warning"
          >
            Not published
          </div>
          <div v-html="content" />
          <template v-if="attachedView">
            <website-list :list="attachedView" />
          </template>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

import { asyncLoader, pageMixin } from '../node-page-website-list-common'

export default {
  name: 'node-page-website-list',
  asyncData: (args) => asyncLoader(args),
  mixins: [
    pageMixin
  ],
  asyncComponents: [
    'website-list',
    'node-website-list-news'
  ],
  props: {
    itemid: {
      type: Number,
      required: true
    }
  },
}
</script>

<style>
.search-region {
  padding: 2em 0em;
  background: #e9e9e9;
}
.search-region .form-control {
  padding: 1.5em;
  min-height: 70px;
  border: 0px;
  box-shadow: none;
  border-radius: 0px;
  font-size: 1.2em;
  color: #353b3b;
}

.search-region .input-group .btn {
  padding: 1.5em 2em;
  min-height: 70px;
  border: 0px;
}

.search-region .input-group .btn i {
  font-size: 2em;
}

#views-exposed-form-positions-vacant-display .views-exposed-form .secondary-filters .views-exposed-widget,
#views-exposed-form-q-and-a-latest .views-exposed-form .secondary-filters .views-exposed-widget,
#views-exposed-form-resources-latest .views-exposed-form .secondary-filters .views-exposed-widget,
#views-exposed-form-event-list-upcoming .views-exposed-form .secondary-filters .views-exposed-widget,
#views-exposed-form-news-latest .views-exposed-form .secondary-filters .views-exposed-widget {
  width: 100%;
  padding-right: 0em;
}

#views-exposed-form-positions-vacant-display .views-exposed-form .secondary-filters .views-filter-region-inner,
#views-exposed-form-q-and-a-latest .views-exposed-form .secondary-filters .views-filter-region-inner,
#views-exposed-form-resources-latest .views-exposed-form .secondary-filters .views-filter-region-inner,
#views-exposed-form-event-list-upcoming .views-exposed-form .secondary-filters .views-filter-region-inner,
#views-exposed-form-news-latest .views-exposed-form .secondary-filters .views-filter-region-inner {
  width: 100% !important;
}

#views-exposed-form-positions-vacant-display .views-exposed-widgets,
#views-exposed-form-q-and-a-latest .views-exposed-widgets,
#views-exposed-form-resources-latest .views-exposed-widgets,
#views-exposed-form-event-list-upcoming .views-exposed-widgets,
#views-exposed-form-news-latest .views-exposed-widgets {
  margin-bottom: 0.5em;
  display: inline-block;
  width: 100%;
}

#views-exposed-form-positions-vacant-display .views-exposed-widgets .views-exposed-widget.views-submit-button,
#views-exposed-form-q-and-a-latest .views-exposed-widgets .views-exposed-widget.views-submit-button,
#views-exposed-form-resources-latest .views-exposed-widgets .views-exposed-widget.views-submit-button,
#views-exposed-form-event-list-upcoming .views-exposed-widgets .views-exposed-widget.views-submit-button,
#views-exposed-form-news-latest .views-exposed-widgets .views-exposed-widget.views-submit-button {
  width: 30%;
}

@media (min-width: 992px) {
  #views-exposed-form-positions-vacant-display .views-exposed-widgets .views-exposed-widget.views-submit-button,
  #views-exposed-form-q-and-a-latest .views-exposed-widgets .views-exposed-widget.views-submit-button,
  #views-exposed-form-resources-latest .views-exposed-widgets .views-exposed-widget.views-submit-button,
  #views-exposed-form-event-list-upcoming .views-exposed-widgets .views-exposed-widget.views-submit-button,
  #views-exposed-form-news-latest .views-exposed-widgets .views-exposed-widget.views-submit-button {
    width: 20%;
  }
}

#views-exposed-form-positions-vacant-display .views-exposed-widgets .views-exposed-widget.views-widget-keys,
#views-exposed-form-q-and-a-latest .views-exposed-widgets .views-exposed-widget.views-widget-keys,
#views-exposed-form-resources-latest .views-exposed-widgets .views-exposed-widget.views-widget-keys,
#views-exposed-form-event-list-upcoming .views-exposed-widgets .views-exposed-widget.views-widget-keys,
#views-exposed-form-news-latest .views-exposed-widgets .views-exposed-widget.views-widget-keys {
  width: 70%;
  padding: 0.5em 0em 0 0;
}

@media (min-width: 992px) {
  #views-exposed-form-positions-vacant-display .views-exposed-widgets .views-exposed-widget.views-widget-keys,
  #views-exposed-form-q-and-a-latest .views-exposed-widgets .views-exposed-widget.views-widget-keys,
  #views-exposed-form-resources-latest .views-exposed-widgets .views-exposed-widget.views-widget-keys,
  #views-exposed-form-event-list-upcoming .views-exposed-widgets .views-exposed-widget.views-widget-keys,
  #views-exposed-form-news-latest .views-exposed-widgets .views-exposed-widget.views-widget-keys {
    width: 80%;
  }
}

#views-exposed-form-positions-vacant-display .views-exposed-widgets .views-exposed-widget .form-text,
#views-exposed-form-positions-vacant-display .views-exposed-widgets .views-exposed-widget select,
#views-exposed-form-positions-vacant-display .views-exposed-widgets .views-exposed-widget textarea,
#views-exposed-form-q-and-a-latest .views-exposed-widgets .views-exposed-widget .form-text,
#views-exposed-form-q-and-a-latest .views-exposed-widgets .views-exposed-widget select,
#views-exposed-form-q-and-a-latest .views-exposed-widgets .views-exposed-widget textarea,
#views-exposed-form-resources-latest .views-exposed-widgets .views-exposed-widget .form-text,
#views-exposed-form-resources-latest .views-exposed-widgets .views-exposed-widget select,
#views-exposed-form-resources-latest .views-exposed-widgets .views-exposed-widget textarea,
#views-exposed-form-event-list-upcoming .views-exposed-widgets .views-exposed-widget .form-text,
#views-exposed-form-event-list-upcoming .views-exposed-widgets .views-exposed-widget select,
#views-exposed-form-event-list-upcoming .views-exposed-widgets .views-exposed-widget textarea,
#views-exposed-form-news-latest .views-exposed-widgets .views-exposed-widget .form-text,
#views-exposed-form-news-latest .views-exposed-widgets .views-exposed-widget select,
#views-exposed-form-news-latest .views-exposed-widgets .views-exposed-widget textarea {
  width: 100%;
  font-size: 1em;
  padding: 1em;
}

#views-exposed-form-positions-vacant-display .views-exposed-widgets .views-exposed-widget .ui-multiselect,
#views-exposed-form-q-and-a-latest .views-exposed-widgets .views-exposed-widget .ui-multiselect,
#views-exposed-form-resources-latest .views-exposed-widgets .views-exposed-widget .ui-multiselect,
#views-exposed-form-event-list-upcoming .views-exposed-widgets .views-exposed-widget .ui-multiselect,
#views-exposed-form-news-latest .views-exposed-widgets .views-exposed-widget .ui-multiselect {
  width: 100% !important;
}

#views-exposed-form-positions-vacant-display .views-exposed-widgets .views-exposed-widget .form-submit,
#views-exposed-form-q-and-a-latest .views-exposed-widgets .views-exposed-widget .form-submit,
#views-exposed-form-resources-latest .views-exposed-widgets .views-exposed-widget .form-submit,
#views-exposed-form-event-list-upcoming .views-exposed-widgets .views-exposed-widget .form-submit,
#views-exposed-form-news-latest .views-exposed-widgets .views-exposed-widget .form-submit {
  margin-top: 0em;
  width: 100%;
  padding: 1em;
}

#views-exposed-form-positions-vacant-display .views-exposed-widgets .advanced-filter-link,
#views-exposed-form-q-and-a-latest .views-exposed-widgets .advanced-filter-link,
#views-exposed-form-resources-latest .views-exposed-widgets .advanced-filter-link,
#views-exposed-form-event-list-upcoming .views-exposed-widgets .advanced-filter-link,
#views-exposed-form-news-latest .views-exposed-widgets .advanced-filter-link {
  text-align: Center;
}

#views-exposed-form-positions-vacant-display .primary-filters label,
#views-exposed-form-q-and-a-latest .primary-filters label,
#views-exposed-form-resources-latest .primary-filters label,
#views-exposed-form-event-list-upcoming .primary-filters label,
#views-exposed-form-news-latest .primary-filters label {
  display: none;
}

#views-exposed-form-positions-vacant-display .primary-filters .form-text,
#views-exposed-form-q-and-a-latest .primary-filters .form-text,
#views-exposed-form-resources-latest .primary-filters .form-text,
#views-exposed-form-event-list-upcoming .primary-filters .form-text,
#views-exposed-form-news-latest .primary-filters .form-text {
  border-radius: 3px 0px 0px 3px;
  border: none;
  box-shadow: none;
  height: 54px;
}

#views-exposed-form-positions-vacant-display .primary-filters .form-submit,
#views-exposed-form-q-and-a-latest .primary-filters .form-submit,
#views-exposed-form-resources-latest .primary-filters .form-submit,
#views-exposed-form-event-list-upcoming .primary-filters .form-submit,
#views-exposed-form-news-latest .primary-filters .form-submit {
  border-radius: 0px 3px 3px 0px;
}

.primary-filters.views-exposed-widgets {
  width: 100%;
  display: inline-block;
}

.primary-filters .views-exposed-form label {
  display: none;
}

.filter-wrapper {
  position: relative;
}

.filter-wrapper .filter-trigger {
  margin-top: 1em;
  text-align: center;
}

.views-exposed-form .views-exposed-widget {
  float: left;
  padding: 0.5em 1em 0 0;
}

.views-exposed-form .views-exposed-widget .form-submit {
  margin-top: 1.6em;
}

.views-exposed-form .form-item,
.views-exposed-form .form-submit {
  margin-top: 0;
  margin-bottom: 0;
}

.views-exposed-form label {
  font-weight: bold;
}

.views-exposed-widgets {
  margin-bottom: 0.5em;
}
.form-submit {
  border: 0 none;
  color: #ffffff;
  text-align: center;
  text-decoration: none;
  padding: 0.6em 1.2em;
  background: #68b75b;
  display: inline-block;
}

.form-submit:hover,
.form-submit:focus {
  text-decoration: none;
  color: #ffffff;
  background: #444444;
  outline: 0;
  cursor: pointer;
}
.node-website-list-event {
  margin: 3em 0em;
}
</style>
